// extracted by mini-css-extract-plugin
export var divider = "_pg-0";
export var systemMessage = "_pg-1";
export var systemMessageWrapper = "_pg-2";